{
  "puan": {
    "Puan Tanımları": "Puan Tanımları",
    "Baslik": "Puan Tanımları",
    "Puan Adı": "Puan Adı",
    "Puan (%)": "Puan (%)",
    "Aralık ve Komisyon Tanımları": "Aralık ve Komisyon Tanımları",
    "Yeni Aralık": "Yeni Aralık",
    "Aralıkları Kopyala": "Aralıkları Kopyala",
    "Unvan": "Unvan",
    "Min %": "Min %",
    "Max %": "Max %",
    "Komisyon %": "Komisyon %",
    "İşlemler": "İşlemler",
    "Puan Ekle": "Puan Ekle",
    "Puan Güncelle": "Puan Güncelle",
    "Aralık Ekle": "Aralık Ekle",
    "Aralık Güncelle": "Aralık Güncelle",
    "Kaydet": "Kaydet",
    "Güncelle": "Güncelle",
    "İptal": "İptal",
    "Sil": "Sil",
    "Puan Tanımını Sil": "Puan Tanımını Sil",
    "Aralık Sil": "Aralık Sil",
    "bu puan tanımını ve bağlı tüm aralıkları silmek istediğinize emin misiniz?": "bu puan tanımını ve bağlı tüm aralıkları silmek istediğinize emin misiniz?",
    "Bu aralık tanımını silmek istediğinize emin misiniz?": "Bu aralık tanımını silmek istediğinize emin misiniz?",
    "Lütfen bir puan tanımı seçiniz": "Lütfen bir puan tanımı seçiniz",
    "için aralıkları başka bir puandan kopyala:": "için aralıkları başka bir puandan kopyala:",
    "Min Yüzde": "Min Yüzde",
    "Max Yüzde": "Max Yüzde",
    "Komisyon (%)": "Komisyon (%)",
    "Unvan Seçiniz": "Unvan Seçiniz",
    "Kaynak Puan": "Kaynak Puan",
    "Puan Seçiniz": "Puan Seçiniz",
    "Kopyala": "Kopyala",
    "Personel Unvan": "Personel Unvan",
    "Data Yenile": "Verileri Güncelle",
    "Komisyon": "Komisyon",
    "Düzeltme": "Düzeltme",
    "Ara": "Arama",
    "Komisyon Hesaplanmaz": "Komisyon Hesaplanmaz",
    "LutfenUnvanSeciniz": "Lütfen önce bir unvan seçiniz"
  }
}
